<div class="chips-container-wrapper" *ngIf="viewModel$ | async as viewModel">
  <section class="header chips-container">
    <ng-container *ngIf="viewModel.jobLoaded; else loading">
      <app-overview-chip
        icon="pi-calendar"
        value="{{ viewModel.totalItems }}"
        label="Items"
      ></app-overview-chip>
      <app-overview-chip
        icon="pi-calendar"
        [value]="'0'"
        label="Boxes"
      ></app-overview-chip>
      <app-overview-chip
        icon="pi-calendar"
        value="{{ viewModel.totalWeight }} {{ viewModel.weightUnit }}"
        label="Weight"
      ></app-overview-chip>
      <app-overview-chip
        icon="pi-calendar"
        value="{{ viewModel.totalVolume }} {{ viewModel.volumeUnit }}"
        label="Volume"
      ></app-overview-chip>
    </ng-container>
  </section>

  <section class="p-mt-4">
    <app-overview-summary
      summaryKey="customerSummary"
      header="Customer Summary"
    ></app-overview-summary>
  </section>

  <app-inventory-table></app-inventory-table>

  <ng-template #loading>
    <p-skeleton
      class="flex-1"
      borderRadius="2.1875rem"
      *ngFor="let _ of [1, 2, 3, 4]"
      width="100%"
      height="4rem"
    />
  </ng-template>
</div>
